import { useQuery } from '@tanstack/react-query'
import api from '@/admin/lib/api'
import { useOrg } from '@/admin/hooks/use-org'

export interface PartnershipAttributeDefinition {
  uuid: string
  code_name: string
  display_name: string
  description: string
  field_type: string
  configuration_data: Record<string, unknown>
  required: boolean
  editable: boolean
  order: number
}

export function usePartnershipAttributes(options: { enabled?: boolean } = {}) {
  const { orgUuid } = useOrg()
  return useQuery<PartnershipAttributeDefinition[]>({
    queryKey: ['partnership-attributes', orgUuid],
    queryFn: () =>
      api
        .get(`/organisations/${orgUuid}/partnership-attributes/`)
        .then((r) => r.data.results ?? r.data),
    enabled: !!orgUuid && (options.enabled ?? true),
    staleTime: 30_000,
  })
}
